var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompactsuvBlueIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119.181,
    height: 68.781,
    viewBox: "0 0 119.181 68.781",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "compactsuv-blue-icon",
    transform: "translate(-69.749 -704.219)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Compact_SUV",
    "data-name": "Compact SUV",
    transform: "translate(77 769)",
    fill: "#04a7e7",
    fontSize: 14,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600,
    letterSpacing: "0.035em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "COMPACT SUV")), /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259",
    transform: "translate(-1139.375 -1812.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M1242.589,2553.632c0-1.965.1-3.848-.018-5.718-.446-6.921-5.966-12.221-12.52-12.1-6.914.123-12.169,5.47-12.366,12.607-.053,1.933.7,4.182-2.68,4.129-3.922-.063-5.381-.97-5.768-4.21a13.108,13.108,0,0,1,10.4-14.861c3-.714,6.023-1.342,9.062-1.845,9.477-1.572,18.733-3.422,27.141-8.713,10.059-6.333,21.513-6.839,33.043-6.137,1.66.1,3.324.332,4.98.28,10.291-.324,19.216,3.408,27.537,9.069a7.187,7.187,0,0,1,3.283,4.813c.914,4.566,1.142,9.209,2.941,13.688,1.969,4.9-.49,7.8-5.671,7.729-1.037-1.34-.372-2.937-.46-4.4-.42-6.924-5.744-12.188-12.433-12.149a12.536,12.536,0,0,0-12.37,12.238c-.23,6-.23,5.962-6.195,5.958-14.609-.01-29.219.023-43.827.011C1245.283,2554.015,1243.832,2554.348,1242.589,2553.632Zm39.186-34.185c-10.242-.842-19.106,2.4-27.485,8.256,2.943-.042,4.67,1.107,4.521,4.146,4.064-.188,7.837-.365,11.609-.538,10.543-.484,10.544-.483,11.516-11.185A3.585,3.585,0,0,0,1281.774,2519.447Zm26.39,9.689c-2.629-3.622-4.361-8.074-9.154-8.934-3.7-.664-7.53-.584-11.3-.9a1.985,1.985,0,0,0-2.46,1.869c-.483,3.1-1.194,6.179-1.037,9.594A175.818,175.818,0,0,0,1308.165,2529.136Z",
    transform: "translate(0 0)",
    fill: "#04a8e8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M1313.818,2559.3c-5-.008-9.726-4.787-9.713-9.82a9.964,9.964,0,0,1,9.488-9.683,9.732,9.732,0,0,1,9.832,9.626C1323.478,2554.584,1318.888,2559.3,1313.818,2559.3Z",
    transform: "translate(-4.683 -1.146)",
    fill: "#04a8e8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M1230.556,2559.25a9.812,9.812,0,0,1-9.386-10.347,9.608,9.608,0,0,1,9.885-9.1,9.947,9.947,0,0,1,9.3,9.807C1240.254,2554.758,1235.513,2559.425,1230.556,2559.25Z",
    transform: "translate(-0.594 -1.147)",
    fill: "#04a8e8",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompactsuvBlueIcon);
export default __webpack_public_path__ + "static/media/compactsuv-blue-icon.4961f13bbe0fd450e40a6c146e828118.svg";
export { ForwardRef as ReactComponent };